module.exports = "https://www.ilove11.top/img/face27.47556db7.gif";